import {useQuery} from '@apollo/client';
import {useCallback} from 'react';
import {useParams} from 'react-router-dom';
import {ListGoals, ListGoalsVariables} from '../schema-types/ListGoals';
import {LIST_GOALS} from '../features/goals/goalsQueries';
import validateUUID from '../utils/validateUUID';

const useAccountGoals = () => {
  const {accountId, reviewId} = useParams();
  const {
    loading: goalsLoading,
    data,
    error: goalsError,
    refetch: refetchGoals,
  } = useQuery<ListGoals, ListGoalsVariables>(LIST_GOALS, {
    variables: {
      accountId: validateUUID(accountId)!,
      reviewId: validateUUID(reviewId),
    },
    nextFetchPolicy: 'network-only',
    fetchPolicy: 'network-only',
  });

  const getGoal = useCallback(
    (id: string) => data?.goals?.find((x) => x.id === id),
    [data]
  );

  return {
    goalsLoading,
    goals: data?.goals || [],
    goalsError,
    getGoal,
    refetchGoals,
  };
};

export default useAccountGoals;
